import type { BaseLocalStorageSchema } from '../../types/localStorage.types';
import { TypedLocalStorage } from '../TypedLocalStorage/TypedLocalStorage';

/** Key prefix used by the system localStorage instance to namespace framework-managed keys. */
export const SYSTEM_KEY_PREFIX = 'app_';

/** Shared typed localStorage instance for framework-managed keys. Use this for any localStorage access that should follow the `app_*` namespace. */
export const SystemLocalStorage = new TypedLocalStorage<BaseLocalStorageSchema>({ keyPrefix: SYSTEM_KEY_PREFIX });
